import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  ACTIVITIES_AND_EVENTS_BOOKED_ACTIVITIES,
  ACTIVITIES_AND_EVENTS_BOOKED_DETAILS_PATH,
  ACTIVITIES_AND_EVENTS_BOOKING_CONFIRMATION_PATH,
  ACTIVITIES_AND_EVENTS_BOOKING_STATUS_PATH,
  ACTIVITIES_AND_EVENTS_DETAILS_PATH,
  ACTIVITIES_AND_EVENTS_FILTER_ACTIVITIES_TYPE_PATH,
  ACTIVITIES_AND_EVENTS_FILTER_PATH,
  ACTIVITIES_AND_EVENTS_OTHER_SESSIONS_PATH,
  ACTIVITIES_AND_EVENTS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const ActivitiesEventPage = lazy(() => import('./pages/ActivitiesEventPage/ActivitiesEventPage'));
const ActivitiesEventFilterPage = lazy(() => import('./pages/ActivitiesEventFilterPage/ActivitiesEventFilterPage'));
const ActivitiesTypeFilterPage = lazy(() => import('./pages/ActivitiesTypeFilterPage/ActivitiesTypeFilterPage'));
const ActivitiesEventDetailsPage = lazy(() => import('./pages/ActivitiesEventDetailsPage/ActivitiesEventDetailsPage'));
const ActivitiesEventOtherSessionsPage = lazy(
  () => import('./pages/ActivitiesEventsOtherSessionsPage/ActivitiesEventsOtherSessionsPage')
);
const BookingsStatusPage = lazy(() => import('./pages/BookingsStatusPage/BookingsStatusPage'));
const BookingsConfirmationPage = lazy(() => import('./pages/BookingsConfirmationPage/BookingsConfirmationPage'));
const BookedActivitiesPage = lazy(() => import('./pages/BookedActivitiesPage/BookedActivitiesPage'));

export const ACTIVITIES_EVENTS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.MOBILE],
    component: () => <ActivitiesEventPage />,
    displayTitle: () => 'Activities & Events',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <ActivitiesEventFilterPage />,
    displayTitle: () => 'Filters',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_FILTER_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
    backUrl: ACTIVITIES_AND_EVENTS_PATH,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <ActivitiesTypeFilterPage />,
    displayTitle: () => 'Activity Type',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_FILTER_ACTIVITIES_TYPE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <ActivitiesEventDetailsPage />,
    displayTitle: () => 'Activity Details',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <ActivitiesEventOtherSessionsPage />,
    displayTitle: () => 'Activities & Events',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_OTHER_SESSIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <ActivitiesEventDetailsPage />,
    displayTitle: () => 'Activity Details',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_BOOKED_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <BookingsStatusPage />,
    displayTitle: () => 'Activities & Events',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_BOOKING_STATUS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
    backUrl: ACTIVITIES_AND_EVENTS_PATH,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <BookingsConfirmationPage />,
    displayTitle: () => 'Activities & Events',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_BOOKING_CONFIRMATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <BookedActivitiesPage />,
    displayTitle: () => 'Activities & Events',
    pageType: PageType.PRIVATE,
    path: ACTIVITIES_AND_EVENTS_BOOKED_ACTIVITIES,
    serviceCatalogCode: SERVICE_CATALOG_CODE.activitiesAndEvents,
  },
];
